import * as React from "react";
import {
  DataGrid,
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridRowCountSelector,
  gridPageSelector,
  gridPageCountSelector,
} from "@mui/x-data-grid";
import { Pagination } from "@mui/material";
import PropTypes from "prop-types";

const PAGE_SIZE = 10;

function CustomFooter() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const from = rowCount === 0 ? 0 : page * PAGE_SIZE + 1;
  const to = Math.min((page + 1) * PAGE_SIZE, rowCount);
  const totalPages = Math.max(pageCount, 1);

  return (
    <GridFooterContainer>
      <div style={{ padding: "0 16px", fontSize: "13px" }}>
        {`${from}-${to} / ${rowCount}件`}
      </div>
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, value) => apiRef.current.setPage(value - 1)}
        size="small"
      />
    </GridFooterContainer>
  );
}

const columns = [
  //{ field: "id", headerName: "ID", width: 30 },
  {
    field: "NickName",
    headerName: "表示名",
    width: 150,
  },
  {
    field: "Furigana",
    headerName: "ふりがな",
    width: 160,
  },
  {
    field: "Sex",
    headerName: "性別",
    width: 60,
    valueGetter: (params) => (params.row.Sex == 1 ? "男" : "女"),
  },
  { field: "Birthday", headerName: "生年月日", width: 110 },
  {
    field: "BodyHeight",
    headerName: "身長",
    type: "number",
    width: 60,
  },
  {
    field: "BodyWeight",
    headerName: "体重",
    type: "number",
    width: 60,
  },
  {
    field: "Prefecture",
    headerName: "都道府県",
    width: 100,
  },
  {
    field: "CareLevel",
    headerName: "介護度",
    width: 90,
    valueGetter: (params) => getCareLevel(params.row.CareLevel),
  },
  {
    field: "id",
    headerName: "システムID",
    width: 320,
  },
];

const getCareLevel = (val) => {
  let level = "";
  switch (val) {
    case 0:
      break;
    case 1:
      level = "要支援１";
      break;
    case 2:
      level = "要支援２";
      break;
    case 3:
      level = "要介護１";
      break;
    case 4:
      level = "要介護２";
      break;
    case 5:
      level = "要介護３";
      break;
    case 6:
      level = "要介護４";
      break;
    case 7:
      level = "要介護５";
      break;
  }

  return level;
};

export default function MemberDataTable({
  ownedMembers,
  setDisplayMode,
  setTargetMember,
  loading,
}) {
  const clicked2 = (element) => {
    if (element.id == undefined || element.id == "") {
      setDisplayMode(2); // 2: 非活性モード
    } else {
      setTargetMember(element.row);
      setDisplayMode(1); // 1: 編集モード
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        rows={ownedMembers ?? []}
        loading={loading ?? false}
        columns={columns}
        pageSize={PAGE_SIZE}
        rowsPerPageOptions={[PAGE_SIZE]}
        checkboxSelection={false}
        density="compact"
        autoHeight
        onRowClick={(ele2) => clicked2(ele2)}
        components={{ Footer: CustomFooter }}
        initialState={{ sorting: { sortModel: [{ field: "Furigana", sort: "asc" }] } }}
      />
    </div>
  );
}

MemberDataTable.propTypes = {
  ownedMembers: PropTypes.object,
  setDisplayMode: PropTypes.any,
  setTargetMember: PropTypes.any,
  loading: PropTypes.bool,
};
